module.exports = __webpack_public_path__ + "img/carLicense.79edb7c9.png";